import {EntityService} from '../../../../service/EntityService';

export class TenantCompanyHistoryService extends EntityService {

  static entity = 'app/tenant-company-history';

}
